import { render, staticRenderFns } from "./IconChooser.vue?vue&type=template&id=e25f4558&scoped=true&"
import script from "./IconChooser.vue?vue&type=script&lang=js&"
export * from "./IconChooser.vue?vue&type=script&lang=js&"
import style0 from "./IconChooser.vue?vue&type=style&index=0&id=e25f4558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25f4558",
  null
  
)

export default component.exports